import React from 'react';
import AboutComponent from 'Common/AboutComponent/AboutComponent.js';
import LoginForm from "./LoginForm.js";
import BranchSelectionForm from "./BranchSelectionForm.js";
import ErrComp from "./ErrComp.js";
import LogInWizard from "./LiveImpexWizard.js";
import LocationSubscriptionReminder from "./LocationSubscriptionReminder.js";
import PaymentMessage from "./PaymentMessage.js";
import TermsAndConditions from "./TermsAndConditions.js";
import LogoAndLinks from "./LogoAndLinks.js";
import InvalidLicComp from "./InvalidLicComp.js";
import { IoArrowBack } from 'react-icons/io5'
import MFARegisterForm from "./MFAForm.js";
import { ToastContainer, toast } from 'react-toastify';


import UserAlreadyLoggedInComp from "./UserAlreadyLoggedInComp.js";
import WarnComponent from "./WarnComponent.js";
import LoginSlider from './LoginSlider.js';
import ErrorBoundary from './LoginErrorBoundary.js';


export default class LoginEntry extends React.Component {
    constructor(props) {
        super(props);

        this.state =
        {            
           
            Screen: {
                showLoginDiv: true,
                showProceedDiv: false,
                showNewPwdDiv: false,
                showPaymentMsgScreen: false,
                showTOUScreen: false,
                ShowPwdChangeWindow: false,
                TOUViewer: false,
                showSubReminder: false,
				
				daysToFinish: this.props.ViewData.Settings.DaysToFinishMFA,
				mfaSkipped: false,
				RegisterMFA: false,
				mfaRegistered: false,
				
				currentPage: "user_info",
				prevPage: "",
            },
            UserDetails: {
                companyDtlList: [],
                locationDtlList: [],

                userCompanyID: -1,
                userCompanyName: '',
                userLocationId: -1,
                userLocationName: '',

                userRoleId: '',
                UserRoleVal: 0,
                isSysAdmin: false,
                isBranchAdmin: false,

                userName: '',
                userPhoto: '',
				defaultCompany: '',
				defaultLocation: '',
            },          
            
            MSG: {
                LocSubscriptionMsg: '',
                paymentCheckMsg: '',
               
            },
            
            CustomWizardSetUp: {
                Show:false,
                CustomBrokerDet: []
            },
            showWarning: this.props.screenType === "PROCCEDWITHWARN",
            showError: this.props.screenType ==="ABORT"
        }
        

    }
	componentDidMount() {

	}

    onKillCurrentClick() {
		if(this.state.Screen.currentPage === "user_info") return;
		if(this.state.Screen.prevPage.length > 0) 
		{
			var addlSetting={Screen: {showLoginDiv:true, currentPage : "user_info"}};
			this.SetActivePage("user_info", addlSetting);
		}
        window.location = window.baseUrl + 'Login/KillCurrentUserSession';
		return;
    }
    setCustomWizardData(CustomWizardObj) {
        try {
            this.setState({ CustomWizardSetUp: CustomWizardObj});
        }
        catch (ex) {
            throw new Error('Login Form crashed- Error in Wizard Form');
        }
    }
    showPaymentMsgTbl(payMsg) {
        this.state.MSG.paymentCheckMsg = payMsg;
        this.state.Screen.showPaymentMsgScreen = true;
        this.setState({});
    }
    showSubReminder(payMsg) {
        this.state.MSG.paymentCheckMsg = payMsg;
        this.state.Screen.showSubReminder = true;
        this.setState({});
    }

    hidePaymentMsgTbl() {
        this.state.Screen.showPaymentMsgScreen = false;
        this.setState({});
    }

    onBtnPaymentMessClick() {
        this.hidePaymentMsgTbl();
    }
    closeSubReminder() {
        this.state.Screen.showSubReminder = false;
        this.setState({ }, () => {
            this.refs.ProceedForm.ShowLoadingScreen();
        });

    }

    
    ShowPaymentReminder() {
        let conStyle = {
            backgroundColor: 'rgba(0,0,0,0.6)',
            zIndex: '999999',
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%'
        }
        if (this.state.Screen.showSubReminder) {
                return(
                < div style = { conStyle } >
                    <AboutComponent style={{ width: "400px", height: "235px" }} headerText="" visible={this.state.Screen.showSubReminder} >
                            <LocationSubscriptionReminder
                               LocSubscriptionMsg={this.state.MSG.LocSubscriptionMsg}
                               closeSubReminder={() => this.closeSubReminder()} />

                    </AboutComponent>

                </div>)
        }

        
        if (this.state.Screen.showPaymentMsgScreen)
            return (
                <div style={conStyle}>
                <PaymentMessage
                        PaymentMessege={this.state.MSG.paymentCheckMsg} onPaymentClick={() => this.onBtnPaymentMessClick()} />
                </div>
                )
        

    }
    ScriptCompatibility() {
        return (
            <noscript>
                <span style={{ color: '#f00' }}>Javascript is not enabled on your browser. Logi-Sys cannot work without javascript.</span>
            </noscript>)
    }
    ShowTitle() {
        if (!this.state.Screen.showProceedDiv)
            return <div className="signin" >
                <p className="signin-style">{this.state.Screen.showTOUScreen ? "Terms And Conditions" : "Sign in Information"}</p>
            </div>
    }
    TOUAccepted(loginInfo) {

        let user = this.state.UserDetails
        let screen = this.state.Screen;
        if (loginInfo != null) {
            let userRole = loginInfo['UserRole'];
            user.userRoleId = userRole;
            user.UserRoleVal = 1;
            user.isSysAdmin = false;
            user.userName = loginInfo['UserName'];
            user.userPhoto = String(loginInfo['UserPhoto']);
            user.isBranchAdmin = true;
            screen.showLoginDiv = false;
            screen.showProceedDiv = true;
            screen.showNewPwdDiv = false;
            screen.showTOUScreen = false;
            screen.currentPage =(
                (this.props.ViewData.Settings.Enable2FactorAuth?.toLowerCase() !== "true") ||
                this.state.Screen.mfaRegistered
              )
                ? "sel_branch"
                : "reg_mfa"

            if (userRole.toLowerCase() == 'global') {
                this.state.UserDetails.companyDtlList = [{ Name: "GLOBAL", CompanyID: -1 }];
            } else {
                let companyDtlList = [];
                let locationDtlList = [];


                if (String(loginInfo['CompanyDetails']).length > 0)
                    companyDtlList = JSON.parse(loginInfo['CompanyDetails']);
                if (String(loginInfo['LocationDetails']).length > 0)
                    locationDtlList = JSON.parse(loginInfo['LocationDetails']);


                user.userCompanyName = (companyDtlList.length > 0 ? companyDtlList[0].Name : "");
                user.companyDtlList = companyDtlList;
                user.userCompanyID = (companyDtlList.length > 0 ? companyDtlList[0].CompanyID : 0);
                user.userLocationId = (locationDtlList.length > 0 ? locationDtlList[0].LocationId : 0);
                user.userLocationName = (locationDtlList.length > 0 ? locationDtlList[0].Location : "");
                user.locationDtlList = locationDtlList;
            }
           

        }
        this.setState({
            Screen: screen, UserDetails: user
        });
    }

   
    ShowRightPanels() {
        let messages = this.props.Messages;
        if (!_PRODUCTINFO.IsValid) {
            return <InvalidLicComp ErrMsg={messages}
            />;
        }
        if (this.props.ViewData != undefined) {
            if (this.props.ViewData.CurrentLoggedUser && this.props.ViewData.CurrentLoggedUser.length > 0)
                return <UserAlreadyLoggedInComp
                    UserName={this.props.ViewData.CurrentLoggedUser}
                    showKillCurrentLnk={true} />;
        }
        if (this.state.Screen.TOUViewer)
            return (<div className="terms">
                <TermsAndConditions
                    showAcceptTOUPnl={false}
                    onHideClick={() => {
                        let screen = this.state.Screen;
                        screen.TOUViewer = false;
                        this.setState({Screen:screen });
                    }}
                />
            </div>);
        if (this.state.Screen.showTOUScreen)
            return (<div className="terms">
                <TermsAndConditions
                    showAcceptTOUPnl={true}
                    onHideClick={(htTOUDtl) => {
                        this.TOUAccepted(htTOUDtl)
                    }}
                />

            </div>);
           

        if (this.state.showError) return (<ErrComp ErrMsg={messages} />);

        let showLoginForm = !this.state.showWarning && !this.state.showError;

		return (<div>
                {this.state.showWarning &&
                    <div>
                    <WarnComponent ErrMsg={messages}
                        onHideClick={() => {
                            this.setState({ showWarning: false });
                        }}
                    />
                    </div>}
					
                {showLoginForm &&
                    (
                    <ErrorBoundary>
					{this.GetLoginPage(this.state.Screen.currentPage)}
					</ErrorBoundary>
                    )
                 }
            </div>)

    }
	SetActivePage(activePageID,otherProps)
	{
		let newState = {...this.state,
			Screen:{...this.state.Screen
					,prevPage:this.state.Screen.currentPage
					,currentPage:activePageID}} 
		if(otherProps)
		{
			if(otherProps.Screen)
				newState = {...newState,Screen:{...newState.Screen, ...otherProps.Screen}};
			else
				newState = {...newState,...otherProps};
		}
		this.setState(newState)
	}

    handleLoginSuccessUpdate = (updatedScreen, updatedUserDetails) => {
        this.setState({
            Screen: { ...this.state.Screen, ...updatedScreen },
            UserDetails: { ...this.state.UserDetails, ...updatedUserDetails }
        });
    };

    handleScreenUpdate = (updatedScreen) => {
        this.setState({
            Screen: { ...this.state.Screen, ...updatedScreen }
        });
    };

	GetLoginPage(thePageID)
	{
		let currentForm=null;
		console.log(`Showing page ${thePageID}`);
		switch(thePageID)
		{
			case "user_info":
				currentForm = <LoginForm
                            ref="LoginForm"
                            Parent={this}
                            Screen={this.state.Screen}
                            SetToUScreen={() => this.setState({ ...this.state, Screen: { ...this.state.Screen, showTOUScreen: true } })}
                            UserDetails={this.state.UserDetails}
                            setCustomWizardData={(CustomWizardData) => this.setCustomWizardData(CustomWizardData)}
                            Settings={this.props.ViewData.Settings}
                            LastLoggedUser={this.props.ViewData.LastLoggedUser}
                            ViewData={this.props.ViewData}
                            MSG={this.state.MSG}
                            showPaymentMsgTbl={(msg) => this.showPaymentMsgTbl(msg)}
                            onLoginSuccess={() => { this.SetActivePage((this.state.Screen.mfaRegistered || this.props.ViewData.Settings.Enable2FactorAuth?.toLowerCase() != "true") ? "sel_branch" : "reg_mfa"); }}
                            onUpdateLoginState={this.handleLoginSuccessUpdate}
                            onScreenUpdate={this.handleScreenUpdate}
                        />
				break;
			case "reg_mfa":
				currentForm = <MFARegisterForm ref="MFARegisterForm" 
						Parent={this} Screen={this.state.Screen} UserDetails={this.state.UserDetails}
						onNext={() => {this.SetActivePage("sel_branch",{Screen: {RegisterMFA:true}});}} 
						onSkip={()=> {this.SetActivePage("sel_branch",{Screen: {mfaSkipped:true, RegisterMFA: false}});}}
					/>
				break;
			case "sel_branch":
				currentForm = <BranchSelectionForm
                        ref="ProceedForm"
                        Parent={this}
                        Screen={this.state.Screen}
                        SetToUScreen={() => this.setState({ ...this.state.Screen, showTOUScreen: true })}
                        UserDetails={this.state.UserDetails}
                        showPaymentMsgTbl={(msg) => this.showPaymentMsgTbl(msg)}
                        MSG={this.state.MSG}
                        showSubReminder={(msg) => this.showSubReminder(msg)}
                        Enable2FactorAuth = {this.props.ViewData.Settings.Enable2FactorAuth}
                    />
				break;
		}
		return currentForm;
	}
	
    ShowMainUI() {
        if (this.state.CustomWizardSetUp.Show) {
            return (
                <div className="WizardStep1" >
                        <ErrorBoundary>
                        <LogInWizard CustomBrokerDet={this.state.CustomWizardSetUp.CustomBrokerDet} ></LogInWizard>
                        </ErrorBoundary>
                </div>)
        }
        else {
            return (
                <div className="center">
                    <div className="Slider">
                        <ErrorBoundary>
                            <LoginSlider showSlider = {!this.state.CustomWizardSetUp.Show || true} />
                         </ErrorBoundary>
                    </div>
                    <div className="login">
                        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '11px' }}>
                            {this.state.Screen.currentPage!=="user_info" &&
                                <div className='proceed_backButton'>
                                <IoArrowBack style={{ fontSize: '21px', color: '#475569' }} onClick={() => this.onKillCurrentClick()} />
                                <span style={{ padding: '4px', fontSize: '11px', color: '#475569' }} onClick={() => this.onKillCurrentClick()}>Back</span>
                                </div>
                            }
                            <img className="logo-text4" src={(_PRODUCTINFO.Logo || "Images/logo.png")} data-att="images/logo.png" alt="Your Browser may not be supporting file companies logo" width="auto" height="140px" />
                        </div>
                        {this.state.Screen.currentPage==="user_info" && <p className='version'>{_PRODUCTINFO.Version}</p>}
                        {this.ShowRightPanels()}
                        {(!this.state.Screen.TOUViewer && !this.state.Screen.showTOUScreen) && <LogoAndLinks showTOUScreen={() =>
                            this.setState(prevState => ({
                                Screen: {
                                    ...prevState.Screen,
                                    TOUViewer: true
                                }
                            }))}
                        />}
                    </div>
                </div>);
        }
    }  
    
    render() {
        return (
            <div>
                <ErrorBoundary>
                {this.ShowMainUI()}
                {this.ShowPaymentReminder()}
				<ToastContainer />
               </ErrorBoundary>
            </div>
        )
    }

}





